module.exports.exportExcelNew = (data, fn_1, fn_2, fn_3, fn_4, fn_5, startDate) => {
    let XLSX = require('xlsx')
    let wb = XLSX.utils.book_new()
    let ws_name = "SheetJS"
    let ws_data = [['ลำดับที่', 'ผู้ที่ได้รับอนุญาตให้ส่งออก', 'ผู้ส่งมอบ', 'เข้าตู้', 'ลำดับที่', 'ปี', 'เลขที่ใบอนุญาต', 'คำสั่งจ่ายงานเลขที่', 'เรือใหญ่', 'เมืองตราส่ง', 'ชนิดข้าว', 'ปริมาณ/ตัน', 'Cert No.',
    // '', '', '', '', '', 
    'ราคา', 'อัตราแลกเปลี่ยน', 'เพิ่มเติม','ชนิดข้าว (EN)']]
    data.map((o, idx) => {
        let countryArr = []
        countryArr.push({t:'s',v:idx + 1} )
        countryArr.push({t:'s',v:fn_1(o['companyEN'])?.toUpperCase()})

        countryArr.push({t:'s',v:fn_1(fn_2(o['godown']))?.toUpperCase()})
        countryArr.push({t:'s',v:fn_4(o['checkWeight']?.['LoaingType'])})
        // console.log('godown')
        countryArr.push({t:'s',v:parseInt(o['subID']) + 1})
        countryArr.push({t:'s',v:`${o['licenseID']}`.slice(6, 8)})
        countryArr.push({t:'s',v:fn_3(o['licenseID'])})
        countryArr.push({t:'s',v:o['jobID'].toString().padStart(5, "0")})
        countryArr.push({t:'s',v:fn_1(fn_5(o['vehicleName']))})
        countryArr.push({t:'s',v:fn_1(o['destinationCity'])?.toUpperCase()})
        // console.log(o['licenseID'],o['subID'],o['wtf1'],o)
 
        countryArr.push({t:'s',v:fn_1(o['wtf1'])?.replaceAll('.', '')})

        let TotalNett = (parseFloat(o['TotalNett']?.replaceAll(',', '')) / 1000).toFixed(2)
        if (Number.isNaN(parseInt(TotalNett))) {
            // TotalNett = (parseFloat(o['checkWeight']['netWeight'])).toFixed(2)
        }
        // console.log(TotalNett)
        countryArr.push({t:'n',v:TotalNett, z:'0.00'})
        countryArr.push({t:'s',v:o['No']})

        // format number column from above line for $0.00




        // countryArr.push([])
        // countryArr.push([])
        // countryArr.push([])
        // countryArr.push([])
        // countryArr.push([])
        countryArr.push({t:'n',v:o['checkWeight']?.['pricePerUnit'] || o['checkWeight']?.['PricePerUnit'], z:'0.00000'})
        countryArr.push({t:'n',v:o['checkWeight']?.['exchangeRate'] || o['checkWeight']?.['ExchangeRate'], z:'0.00000'})
        countryArr.push({t:'s',v:fn_1(o['checkWeight']?.['riceTypeName'])})

        // console.log(o) 
        countryArr.push({t:'s',v:fn_1(o['wtf1'])?.replaceAll('.', '')})

        // console.log(countryArr)
        ws_data.push(countryArr)
    })
    // console.log(ws_data)
    var ws = XLSX.utils.aoa_to_sheet(ws_data)
    XLSX.utils.book_append_sheet(wb, ws, ws_name)
    XLSX.writeFile(wb, `stats_daily_${startDate}.xlsx`)

    // console.log('hello')
}

module.exports.exportExcelMultipleNew = (data, fn_1, fn_2, fn_3, fn_4, fn_5, startDate) => {
    let XLSX = require('xlsx')
    let wb = XLSX.utils.book_new()
    let ws_name = "SheetJS"
    let ws_data = [['ลำดับที่', 'ผู้ที่ได้รับอนุญาตให้ส่งออก', 'ผู้ส่งมอบ', 'เข้าตู้', 'ลำดับที่', 'ปี', 'เลขที่ใบอนุญาต', 'คำสั่งจ่ายงานเลขที่', 'เรือใหญ่', 'เมืองตราส่ง', 'ชนิดข้าว', 'ปริมาณ/ตัน', '', '', '', '', '', 'ราคา', 'อัตราแลกเปลี่ยน', 'เพิ่มเติม', 'ทดสอบพิกัด']]
    data.map((o, idx) => {
        let countryArr = []
        countryArr.push(idx + 1)
        countryArr.push(fn_1(o['companyEN'])?.toUpperCase())
        countryArr.push(fn_1(fn_2(o['godown']))?.toUpperCase())
        countryArr.push(fn_4(o['checkWeight']?.['LoaingType']))
        countryArr.push(parseInt(o['subID']) + 1)
        countryArr.push(`${o['licenseID']}`.slice(6, 8))
        countryArr.push(fn_3(o['licenseID']))
        countryArr.push(o['jobID'])
        countryArr.push(fn_1(fn_5(o['vehicleName'])))
        countryArr.push(fn_1(o['destinationCity'])?.toUpperCase())
        // console.log(o['licenseID'],o['subID'],o['wtf1'],o)
        countryArr.push(fn_1(o['wtf1'])?.replaceAll('.', ''))
        countryArr.push((parseFloat(o['TotalNett']?.replaceAll(',', '')) / 1000).toFixed(2))
        countryArr.push([])
        countryArr.push([])
        countryArr.push([])
        countryArr.push([])
        countryArr.push([])
        countryArr.push(o['checkWeight']?.['pricePerUnit'] || o['checkWeight']?.['PricePerUnit'])
        countryArr.push(o['checkWeight']?.['exchangeRate'] || o['checkWeight']?.['ExchangeRate'])
        countryArr.push(o['checkWeight']?.['riceTypeName'])
        countryArr.push(o['checkWeight']?.['TariffType'])
        // console.log(countryArr)
        ws_data.push(countryArr)
    })
    // console.log(ws_data)
    var ws = XLSX.utils.aoa_to_sheet(ws_data)
    XLSX.utils.book_append_sheet(wb, ws, ws_name)
    XLSX.writeFile(wb, `stats_daily_${startDate}.xlsx`)

    // console.log('hello')
} 
module.exports.exportExcelParboild = (data, fn_1, fn_2, fn_3, fn_4, fn_5, startDate) => {
    let XLSX = require('xlsx')
    let wb = XLSX.utils.book_new()
    let ws_name = "SheetJS"
    let unique = []
    let ws_data = [['ลำดับที่', 'ผู้ที่ได้รับอนุญาตให้ส่งออก', 'ผู้ส่งมอบ', 'เข้าตู้', 'ลำดับที่', 'ปี', 'เลขที่ใบอนุญาต', 'คำสั่งจ่ายงานเลขที่', 'เรือใหญ่', 'เมืองตราส่ง', 'ชนิดข้าว', 'ปริมาณ/ตัน', '', '', '', '', '', 'ราคา', 'อัตราแลกเปลี่ยน']]
    data.map((o, idx) => {
        let countryArr = []
        let uniqueID = `${o['licenseID']}${o['jobID']}${parseInt(o['subID']) + 1}`
        if (unique.indexOf(uniqueID) == -1 && o['licenseID'] != '99999999') {
            unique.push(uniqueID)
            countryArr.push(idx + 1)
            countryArr.push(fn_1(o['companyEN'])?.toUpperCase())
            countryArr.push(fn_1(fn_2(o['godown']))?.toUpperCase())
            countryArr.push(fn_4(o['checkWeight']?.['LoaingType']))
            countryArr.push(parseInt(o['subID']) + 1)
            countryArr.push(`${o['licenseID']}`.slice(6, 8))
            countryArr.push(fn_3(o['licenseID']))
            countryArr.push(o['jobID'])
            countryArr.push(fn_1(fn_5(o['vehicleName'])))
            countryArr.push(fn_1(o['destinationCity'])?.toUpperCase())
            countryArr.push(fn_1(o['wtf1'])?.replaceAll('.', ''))
            let TotalNett = (parseFloat(o['TotalNett']?.replaceAll(',', '')) / 1000).toFixed(2)
            if (Number.isNaN(parseInt(TotalNett))) {
                // TotalNett = (parseFloat(o['checkWeight']['netWeight'])).toFixed(2)
            }

            countryArr.push({t:'n',v:TotalNett, z:'0.00'})
            countryArr.push([])
            countryArr.push([])
            countryArr.push([])
            countryArr.push([])
            countryArr.push([])
            countryArr.push(o['checkWeight']?.['pricePerUnit'] || o['checkWeight']?.['PricePerUnit'])
            countryArr.push(o['checkWeight']?.['exchangeRate'] || o['checkWeight']?.['ExchangeRate'])
            countryArr.push(o['checkWeight']?.['riceTypeName'])

            if (Number.isNaN(parseInt(TotalNett))) {
                // TotalNett = (parseFloat(o['checkWeight']['netWeight'])).toFixed(2)
            }else{
                ws_data.push(countryArr)
            }
            // console.log(countryArr)
        }
    })
    // console.log(ws_data)
    var ws = XLSX.utils.aoa_to_sheet(ws_data)
    XLSX.utils.book_append_sheet(wb, ws, ws_name)
    XLSX.writeFile(wb, `stats_daily_parboiled_${startDate}.xlsx`)

    // console.log('hello')
}


module.exports.exportExcelMultipleParboild = (data, fn_1, fn_2, fn_3, fn_4, fn_5, startDate) => {
    let XLSX = require('xlsx')
    let wb = XLSX.utils.book_new()
    let ws_name = "SheetJS"
    let ws_data = [['ลำดับที่', 'ผู้ที่ได้รับอนุญาตให้ส่งออก', 'ผู้ส่งมอบ', 'เข้าตู้', 'ลำดับที่', 'ปี', 'เลขที่ใบอนุญาต', 'คำสั่งจ่ายงานเลขที่', 'เรือใหญ่', 'เมืองตราส่ง', 'ชนิดข้าว', 'ปริมาณ/ตัน', '', '', '', '', '', 'ราคา', 'อัตราแลกเปลี่ยน', 'เพิ่มเติม', 'ทดสอบพิกัด']]
    console.log(data)
    data.map((o, idx) => {
        let countryArr = []
        countryArr.push(idx + 1)
        countryArr.push(fn_1(o['companyEN'])?.toUpperCase())
        countryArr.push(fn_1(fn_2(o['godown']))?.toUpperCase())
        countryArr.push(fn_4(o['checkWeight']?.['LoaingType']))
        countryArr.push(parseInt(o['subID']) + 1)
        countryArr.push(`${o['licenseID']}`.slice(6, 8))
        countryArr.push(fn_3(o['licenseID']))
        countryArr.push(o['jobID'])
        countryArr.push(fn_1(fn_5(o['vehicleName'])))
        countryArr.push(fn_1(o['destinationCity'])?.toUpperCase())
        // console.log(o['licenseID'],o['subID'],o['wtf1'],o)
        countryArr.push(fn_1(o['wtf1'])?.replaceAll('.', ''))
        countryArr.push((parseFloat(o['TotalNett']?.replaceAll(',', '')) / 1000).toFixed(2))
        countryArr.push([])
        countryArr.push([])
        countryArr.push([])
        countryArr.push([])
        countryArr.push([])
        countryArr.push(o['checkWeight']?.['pricePerUnit'] || o['checkWeight']?.['PricePerUnit'])
        countryArr.push(o['checkWeight']?.['exchangeRate'] || o['checkWeight']?.['ExchangeRate'])
        countryArr.push(o['checkWeight']?.['riceTypeName'])
        countryArr.push(o['checkWeight']?.['TariffType'])
        // console.log(countryArr)
        ws_data.push(countryArr)
    })
    // console.log(ws_data)
    var ws = XLSX.utils.aoa_to_sheet(ws_data)
    XLSX.utils.book_append_sheet(wb, ws, ws_name)
    XLSX.writeFile(wb, `stats_daily_${startDate}.xlsx`)

    // console.log('hello')
}

module.exports.exportExcel = (data, filter) => {
    let XLSX = require('xlsx')
    let wb = XLSX.utils.book_new()
    let ws_name = "SheetJS"

    let ws_data = [[''].concat(filter).concat(['valueTHB', 'valueUSD'])]
    Object.keys(data).map((countryName) => {
        let countryArr = [countryName]
        filter.map((filterName) => {
            if (data[countryName][filterName]) {
                countryArr.push(data[countryName][filterName])
            } else {
                countryArr.push('-')
            }
        })
        countryArr.push(data[countryName]['valueTHB'])
        countryArr.push(data[countryName]['valueUSD'])
        ws_data.push(countryArr)
    })
    // console.log(ws_data)
    var ws = XLSX.utils.aoa_to_sheet(ws_data)
    XLSX.utils.book_append_sheet(wb, ws, ws_name)
    XLSX.writeFile(wb, `${filter[0]}-${filter[filter.length]}.xlsx`)

    // console.log('hello')
}
module.exports.getFilterData = () => {
    const BrokenFilter = [
        'THAIFRAGRANTWHITEBROKENRICEA1EXTRASUPER',
        'THAIFRAGRANTWHITEBROKENRICEA1SUPER',
        'WHITEBROKENRICEA1EXTRASUPER',
        'WHITEBROKENRICEA1SUPER',
        'WHITEBROKENRICEASPERSAMPLE',
        'WHITEBROKENRICEC1ASPERSAMPLE',
        'WHITEBROKENRICEENRICHEDVITAMINASPERSAMPLE',
    ]
    const BoiledFilter = [
        'CARGOPARBOILEDRICEASPERSAMPLE',
        'PARBOILEDBROKENRICEA1',
        'PARBOILEDBROKENRICEASPERSAMPLE',
        'PARBOILEDRICE100',
        'PARBOILEDRICE100SORTED',
        'PARBOILEDRICE10',
        'PARBOILEDRICE10SORTED',
        'PARBOILEDRICE15',
        'PARBOILEDRICE25',
        'PARBOILEDRICE5',
        'PARBOILEDRICE5SORTED',
        'PARBOILEDRICEASPERSAMPLE',
    ]
    const WR10 = [
        'THAIFRAGRANTWHITERICE10',
        'WHITERICE10',
    ]
    const WR100 = [
        'THAIFRAGRANTWHITERICE100',
        'WHITERICE100A',
        'WHITERICE100B',
        'WHITERICE100C',
    ]
    const WR15 = [
        'THAIFRAGRANTWHITERICE15',
        'WHITERICE15',
    ]
    const WR25 = [
        'WHITERICE25',
        'WHITERICE25SUPER',
    ]
    const MIX35 = [
        'WHITERICE35',
        'BASMATIWHITERICEASPERSAMPLE',
        'JAPONICASHORTGRAINWHITERICEASPERSAMPLE',
        'SHORTGRAINWHITERICEASPERSAMPLE',
        'SPECIALMIXEDRICEASPERSAMPLE',
        'THAIFRAGRANTWHITERICEASPERSAMPLE',
        'WHITERICE100ASPERSAMPLE',
        'WHITERICE10ASPERSAMPLE',
        'WHITERICE15ASPERSAMPLE',
        'WHITERICE25ASPERSAMPLE',
        'WHITERICE5ASPERSAMPLE',
        'WHITERICEASPERSAMPLE',
        'WHITERICEENRICHEDVITAMINASPERSAMPLE',
    ]
    const WR5 = [
        'THAIFRAGRANTWHITERICE5',
        'WHITERICE5',
    ]
    const WHITERICE = [
        'THAIFRAGRANTWHITERICE100',
        'THAIFRAGRANTWHITERICE5',
        'THAIFRAGRANTWHITERICE10',
        'THAIFRAGRANTWHITERICE15',
        'THAIFRAGRANTWHITERICEASPERSAMPLE',
        'THAIFRAGRANTWHITEBROKENRICEA1EXTRASUPER',
        'THAIFRAGRANTWHITEBROKENRICEA1SUPER'
    ]
    const CARGORICE = [
        'THAIFRAGRANTCARGORICE100',
        'THAIFRAGRANTCARGORICE5',
        'THAIFRAGRANTCARGORICE10',
        'THAIFRAGRANTCARGORICE15',
        'THAIFRAGRANTCARGORICEASPERSAMPLE',
    ]
    const AllFilter = {
        BrokenFilter: BrokenFilter,
        BoiledFilter: BoiledFilter,
        WHITERICE: WHITERICE,
        CARGORICE: CARGORICE,
        MIX35: MIX35,
        WR5: WR5,
        WR10: WR10,
        WR15: WR15,
        WR25: WR25,
        WR100: WR100,
    }
    return AllFilter
}
module.exports.getBoiledRiceFilter = () => {
    let filterData = this.getFilterData()
    return filterData['BoiledFilter']
}
module.exports.getWhiteRiceMixFilter = () => {
    let filterData = this.getFilterData()
    let output = filterData['WR5']
        .concat(filterData['WR10'])
        .concat(filterData['WR15'])
        .concat(filterData['WR25'])
        .concat(filterData['MIX35'])
        .concat(filterData['BrokenFilter'])
    return output
}
module.exports.getCargoRiceFilter = () => {
    let filterData = this.getFilterData()
    return filterData['CARGORICE']
}
module.exports.getWhiteRiceFilter = () => {
    let filterData = this.getFilterData()
    return filterData['WHITERICE']
}
